import gql from 'graphql-tag';

export const load = gql`
  query getProductProperties($limit: Int, $offset: Int, $orderBy: [ProductPropertyOrder!]) {
    getProductProperties(limit: $limit, offset: $offset, orderBy: $orderBy) {
      totalCount
      productProperties {
        id
        entityId
        displayName
        name
        type
        unit
        createdAt
        createdByUser {
          fullName
        }
        updatedAt
        updatedByUser {
          fullName
        }
        expression
        usages {
          numberOfTimes
          resourceId
          type
          updatedAt
        }
      }
    }
  }
`;
